import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axios";
import DOMPurify from "dompurify";

const SponsorDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sponsor, setSponsor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    axiosInstance
      .get(`/api/sponsors/${id}`)
      .then((res) => setSponsor(res.data))
      .catch(() => setSponsor(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="animate-spin w-10 h-10 border-2 border-[#BA1500] border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!sponsor) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <p className="text-gray-600 mb-4">Sponsor not found.</p>
        <button
          onClick={() => navigate("/sponsors")}
          className="text-[#BA1500] font-semibold hover:underline"
        >
          Back to Sponsors
        </button>
      </div>
    );
  }

  const safeHtml = sponsor.description
    ? DOMPurify.sanitize(sponsor.description)
    : "";

  return (
    <div className="flex flex-col items-center mx-auto w-full px-4 sm:px-6 max-w-4xl py-8">
      <button
        onClick={() => navigate("/sponsors")}
        className="self-start text-[#BA1500] font-semibold hover:underline mb-6"
      >
        ← Back to Sponsors
      </button>
      <h1 className="text-2xl sm:text-3xl font-bold text-[#BA1500] mb-6 text-center">
        {sponsor.name}
      </h1>
      {safeHtml ? (
        <div
          className="prose prose-lg max-w-none w-full text-gray-800"
          dangerouslySetInnerHTML={{ __html: safeHtml }}
        />
      ) : (
        <p className="text-gray-600 text-center">No description yet.</p>
      )}
    </div>
  );
};

export default SponsorDetail;
